import { Box, Typography } from '@mui/material';

import TableBodySkeleton from '../skeletons/TableBodySkeleton';

/**
 * Tarjeta de tablero con el formato de Finanzas: encabezado con título y cuerpo para gráfico
 * o tabla.
 * @param {Object} props
 * @param {string} props.title Título de la tarjeta.
 * @param {JSX.Element} props.children Gráfico o tabla.
 * @param {boolean} [props.loading] Muestra skeleton mientras carga.
 * @param {boolean} [props.hasData] Si es falso, muestra el mensaje de vacío.
 * @param {number|string} [props.height] Alto del cuerpo; `auto` para tablas.
 * @param {string} [props.emptyMessage] Mensaje cuando no hay datos.
 * @param {Object} [props.bodySx] Estilos adicionales del cuerpo.
 * @param {string} [props.variant] `card` (con borde, Finanzas) o `plain` (sin borde ni divisor).
 * @returns {JSX.Element}
 */
const DashboardChartCard = ({
  title,
  children,
  loading = false,
  hasData = true,
  height = 300,
  emptyMessage = 'Sin datos para graficar',
  bodySx = {},
  variant = 'card',
}) => (
  <Box
    sx={{
      border: variant === 'plain' ? 0 : '1px solid',
      borderColor: 'divider',
      borderRadius: 1,
      backgroundColor: 'background.paper',
      minWidth: 0,
      overflow: 'hidden',
    }}
  >
    <Box
      sx={{
        px: variant === 'plain' ? 0.5 : 1.75,
        py: variant === 'plain' ? 0.5 : 1.25,
        borderBottom: variant === 'plain' ? 0 : '1px solid',
        borderColor: 'divider',
        backgroundColor: 'background.paper',
      }}
    >
      <Typography variant="subtitle2" sx={{ color: 'primary.main', fontWeight: 800 }}>
        {title}
      </Typography>
    </Box>
    <Box sx={{ height, p: 1.5, minWidth: 0, ...bodySx }}>
      {loading ? (
        <TableBodySkeleton rows={4} variant="box" />
      ) : hasData ? children : (
        <Box
          sx={{
            height: '100%',
            minHeight: 120,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600 }}>
            {emptyMessage}
          </Typography>
        </Box>
      )}
    </Box>
  </Box>
);

export default DashboardChartCard;
